import styled from "styled-components";

export const StyledNav = styled("div")`
  &.hide {
    display: none;
    @media screen and (min-width: 768px) {
      display: block;
    }
  }
  &.showMobile {
    display: block;
    @media screen and (min-width: 768px) {
      display: none;
    }
  }
`;

/* every row carries a 2px left rail so text stays aligned; active turns it red */
export const StyledSingleNavItem = styled("div")`
  padding: 0.5rem 0.625rem;
  border-left: 2px solid transparent;
  &.active {
    border-left-color: #ee0000;
  }
`;

export const StyledChildLink = styled("div")`
  padding: 0.5rem 0.625rem 0.5rem 1.5rem;
  border-left: 2px solid transparent;
  &.active {
    border-left-color: #ee0000;
  }
`;

export const StyledTextLink = styled("div")`
  margin-left: 0;
`;
